/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createReturnCallMessage } from 'calling-lifecycle-messages/deviceEventCreators';
export const sendReturnCallMessage = ({
  activeConnectionId,
  callId,
  fromNumber,
  fromNumberFriendlyName,
  toNumber
}) => {
  sendCrossTabMessage(createReturnCallMessage({
    destinationConnectionId: activeConnectionId,
    fromNumber,
    fromNumberFriendlyName,
    toNumber,
    callId
  }));
};